import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Denied({ idVariant = '', className }: Props) {
  return (
    <IconBase name="denied" w={20} className={className}>
      <path d="M13.475 14.8906L5.10938 6.525C4.40938 7.50625 4 8.70625 4 10C4 13.3125 6.6875 16 10 16C11.2969 16 12.4969 15.5906 13.475 14.8906ZM14.8906 13.475C15.5906 12.4938 16 11.2938 16 10C16 6.6875 13.3125 4 10 4C8.70312 4 7.50313 4.40938 6.525 5.10938L14.8906 13.475ZM2 10C2 5.58125 5.58125 2 10 2C14.4187 2 18 5.58125 18 10C18 14.4187 14.4187 18 10 18C5.58125 18 2 14.4187 2 10Z" fill="currentColor"/>
    </IconBase>
  )
}

export default Denied
